import { FullScreenLoaderProps } from '@customTypes/PropTypes';
import './FullScreenLoader.scss';

const FullScreenLoader = ({ isLoading, isTransparent = true, classOverride = '' } : FullScreenLoaderProps) => (
    isLoading ? (
        <div className={`loader-background ${classOverride} ${isTransparent ? 'transparent' : 'opaque'}`}>
            <span className="full-screen-loader" />
        </div>
    ) : null
);

export default FullScreenLoader;
